
import $ from "jquery"
import serialize from "form-serialize"

import q_ajax_3 from "app/utils/q_ajax/q_ajax_3"

interface Selector {
  scope:        string | JQuery
  main:         string | JQuery
  form:         string | JQuery
  input:        string | JQuery
  update_btn:   string | JQuery
  edit_btn:     string | JQuery
}

interface InputSelector {
  scope?:       string | JQuery
  main?:        string | JQuery
  form?:        string | JQuery
  input?:       string | JQuery
  update_btn?:  string | JQuery
  edit_btn?:    string | JQuery
}

const DEFAULT_SELECTOR = {
  scope:        ".page--single-listings-detail-page--main-section",
  main:         ".page--single-listings-detail-page--main-section__internal--main",
  form:         ".page--single-listings-detail-page--main-section__internal--form",
  input:        ".page--single-listings-detail-page--main-section__internal--form--input",
  update_btn:   ".page--single-listings-detail-page--main-section__internal--button-update",
  edit_btn:     ".page--single-listings-detail-page--main-section__internal--button-edit",
}

let original_text = ""

class ListerInternalRemark {
  private selector: Selector

  private $scope: JQuery
  private $el: JQuery
  private $form: JQuery
  private $input: JQuery
  private $edit_btn: JQuery
  private $update_btn: JQuery

  constructor(selector?: InputSelector) {
    this.selector = Object.assign({}, DEFAULT_SELECTOR, selector)

    this.$scope = $(this.selector.scope)
    this.$el = this.$scope.find(this.selector.main)
    this.$form = this.$el.find(this.selector.form)
    this.$input = this.$form.find(this.selector.input)
    this.$edit_btn = this.$el.find(this.selector.edit_btn)
    this.$update_btn = this.$form.find(this.selector.update_btn)

    this.bind_action()
  }

  private setToDisplayMode(){
    this.$el.addClass("display-mode")
    this.$input.prop("disabled", true)
  }

  private setToEditMode(){
    original_text = this.$input.val()

    this.$el.removeClass("display-mode")
    this.$input.prop("disabled", false)
  }

  private bind_action(){
    this.$edit_btn.on("click", () => {
      this.setToEditMode()
    })

    this.$update_btn.on("click", (e) => {
      e.preventDefault()

      return q_ajax_3(
        {
          url:      this.$form.attr("action"),
          method:   "POST",
          dataType: "json",
          data:     serialize((this.$form[0] as HTMLFormElement), {hash: true}),
        },
      )
      .then(() => {
        this.setToDisplayMode()
      })
      .catch((reason_or_error) => {
        if (reason_or_error instanceof Error) {
          throw reason_or_error
        }

        this.$input.val(original_text)
        this.setToDisplayMode()
      })
    })
  }
}

const Factory = {
  create(selector?: InputSelector){
    return new ListerInternalRemark(selector)
  },
}

export { Factory as default }
